var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try {
            step(generator.next(value));
        }
        catch (e) {
            reject(e);
        } }
        function rejected(value) { try {
            step(generator["throw"](value));
        }
        catch (e) {
            reject(e);
        } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useEffect, useState } from "@discovery/common-dplus/lib/hooks";
import { Fold, Lens } from "@discovery/prelude/lib/control/lens";
import * as M from "@discovery/prelude/lib/data/maybe";
import { optional, record, string, } from "@discovery/prelude/lib/data/validated";
import { clientInformation } from "@discovery/common-dplus/lib/device-info";
import { envBrowser } from "@discovery/maestro-env-browser";
import * as E from "fp-ts/Either";
import * as App from "@discovery/maestro";
import * as User from "@discovery/sonic-api-ng/lib/api/users/me";
// import * as Res from "@discovery/sonic-api-ng/lib/japi/response";
import * as Profile from "@discovery/sonic-api-ng/lib/api/users/profiles";
import * as RecentSearch from "@discovery/sonic-api-ng/lib/api/users/custom-attributes";
import { getUrlParameter } from "../../../../utils/common";
import { AllAccessLogin } from "../afterPinSetModals/allaccessLogin";
import { GetInTouch } from "../afterPinSetModals/getIntouchWithUs";
import { ResetPin } from "../afterPinSetModals/resetPin";
import { ResetSecurityQuestionCard } from "../afterPinSetModals/resetSecurityQuestions";
import { CreatePin } from "../parental-lock-first-flow/create-pin-flow";
import { SecurityQuestionCard } from "./setSecurityQuestions";
import { Sucess } from "./sucess";
import { navigateTo } from "../../../../utils/common";
import { _UserProfiles } from "../../../../component-creators/hamburger/optics";
import Strings from "../../../../utils/hardcoded.json";
import { config } from "@discovery/common-dplus/lib/utils/config-types";
import { updateGlobalState } from "@discovery/common-dplus/lib/hooks";
export const ParentalLock = ({ route, toggleAllAccess, pinValidation, read, userId, recoveryq1CustomAttr, recoveryq2CustomAttr, timeOut, onBackHandlerAfterTimeLock, timeLockVisibilityEvent, hideAllAccessPopup, parentalLockKeyCustomAttribute, nativeUrl, allowAllAccess, showAllAccessAfterTimeLock, }) => {
    const [pathName, setPathName] = useState("");
    const [allAccessProfileId, setAllAccessProfileId] = useState("");
    const [resetPin, setResetPin] = useState("");
    const setQueryParam = (queryParams, q, key) => {
        const url = window.location.href;
        const searchParams = new URLSearchParams(window.location.search);
        searchParams.set("allAccess", key);
        const newParams = searchParams.toString();
        const queryString = url.indexOf("?") ? newParams : queryParams;
        const newurl = window.location.pathname + `${"?" + queryString}`;
        window.history.pushState({ path: newurl }, "", newurl);
        const pathName = getUrlParameter(q);
        pathName && setPathName(pathName);
    };
    const watchQueryParams = () => {
        const url = new URL(window.location.href);
        const route = url.searchParams.get("allAccess");
        if (route === null)
            toggleAllAccess && toggleAllAccess();
        const pathName = getUrlParameter("allAccess");
        pathName && setPathName(pathName);
    };
    const getUserProfiles = () => __awaiter(void 0, void 0, void 0, function* () {
        const endpoint = Profile.Endpoints.getProfiles();
        yield App.run(endpoint)(Object.assign(Object.assign(Object.assign({}, envBrowser), read), { clientInformation: clientInformation })).then(E.fold((_exception) => {
            /* handle exception here */
        }, (response) => {
            const userProfilesM = Fold.preview(_UserProfiles, response);
            const userProfiles = M.fromMaybe(userProfilesM, []);
            const defaultProfile = userProfiles.filter((item) => M.fromMaybe(item.attributes.profileName, "") === "all-access");
            const defaultProfileId = defaultProfile[0] && defaultProfile[0].id; //since there will be only one default profile
            defaultProfileId && setAllAccessProfileId(defaultProfileId);
        }));
    });
    const onContinue = (step) => {
        switch (step) {
            case "step1":
                return setQueryParam("?allAccess=login", "allAccess", "login");
            case "step2":
                return setQueryParam("?allAccess=resetPin", "allAccess", "resetPin");
            case "step3":
                return setQueryParam("?allAccess=recoveryQ", "allAccess", "recoveryQ");
            case "step4":
                return setQueryParam("?allAccess=success", "allAccess", "success");
            case "step5":
                return setQueryParam("?allAccess=forgotPin", "allAccess", "forgotPin");
            case "step6":
                return setQueryParam("?allAccess=resetRecoveryQ", "allAccess", "resetRecoveryQ");
            case "step7":
                return setQueryParam("?allAccess=forgotAnswer", "allAccess", "forgotAnswer");
            case "step8":
                return setQueryParam("?allAccess=createPin", "allAccess", "createPin");
        }
    };
    const switchUserProfileToAllAccess = (selectedProfileId) => __awaiter(void 0, void 0, void 0, function* () {
        if (read && userId) {
            const endpoint = User.Endpoints.patchMe(userId, selectedProfileId);
            yield App.run(endpoint)(Object.assign(Object.assign(Object.assign({}, envBrowser), read), { clientInformation: clientInformation })).then(E.fold((_exception) => {
                /* handle exception here */
            }, () => {
                sessionStorage.setItem("pA", "true");
                allowAllAccess && allowAllAccess();
                timeLockVisibilityEvent &&
                    sessionStorage.setItem("timeLockVisibility", "true");
                try {
                    localStorage.setItem("isAllAccess", "true");
                }
                catch (e) {
                    console.info(e);
                }
                onContinue("step4");
            }));
        }
    });
    const postParentalCustomAttributes = (pin, recoveryResponse1, recoveryResponse2) => {
        const customAttrValidator = optional(record({
            pin: string,
            recoveryResponse1: string,
            recoveryResponse2: string,
        }));
        const postCustomAttributeReq = {
            parentalLock: { pin, recoveryResponse1, recoveryResponse2 },
        };
        const postRequest = RecentSearch.Endpoints.putCustomAttributes(parentalLockKeyCustomAttribute, postCustomAttributeReq, customAttrValidator);
        App.run(postRequest)(Object.assign(Object.assign(Object.assign({}, envBrowser), read), { clientInformation: clientInformation })).then(E.fold((_exception) => {
            /* handle exception here */
        }, () => {
            allAccessProfileId &&
                switchUserProfileToAllAccess({
                    selectedProfileId: allAccessProfileId,
                });
        }));
    };
    useEffect(() => {
        getUserProfiles();
        window.addEventListener("popstate", watchQueryParams);
        return function cleanUp() {
            window.removeEventListener("popstate", watchQueryParams);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const parentalLockSuccess = () => {
        try {
            localStorage.setItem("isSuccessPa", "true");
        }
        catch (e) {
            console.info(e);
        }
        if (nativeUrl) {
            navigateTo(nativeUrl);
        }
        else {
            navigateTo(config.standardPageRouteFragments.allAccess);
        }
    };
    const recoveryQuestionHandler = (answer1, answer2) => {
        postParentalCustomAttributes(resetPin, answer1, answer2);
    };
    const resetRecoveryQuestionHandler = () => {
        onContinue("step8");
    };
    const onForgotPinRecoveryQuestionHandler = () => {
        onContinue("step7");
    };
    const onCreateNewPinHandler = (id) => {
        postParentalCustomAttributes(id, recoveryq1CustomAttr, recoveryq2CustomAttr);
    };
    const onContinuePinValidationSuccess = () => {
        updateGlobalState(Lens.prop("isParentalLockAccess"))((_isParentalLockAccess) => true);
        switchUserProfileToAllAccess({
            selectedProfileId: allAccessProfileId,
        });
    };
    const onContinueResetPinHandler = (id) => {
        setResetPin(id);
        onContinue("step3");
    };
    const goBack = () => {
        window.history.back();
    };
    const renderPages = (route) => {
        switch (pathName.length > 0 ? pathName : route) {
            case "landing":
                return (React.createElement(AllAccessLogin, { onBack: goBack, forgotPin: () => onContinue("step5"), resetPin: () => onContinue("step2"), onContinue: () => onContinuePinValidationSuccess(), pinValidation: pinValidation, timeOut: timeOut, onBackHandlerAfterTimeLock: onBackHandlerAfterTimeLock, hideAllAccessPopup: hideAllAccessPopup, showAllAccessAfterTimeLock: showAllAccessAfterTimeLock }));
            case "login":
                return (React.createElement(AllAccessLogin, { onBack: goBack, forgotPin: () => onContinue("step5"), resetPin: () => onContinue("step2"), onContinue: () => onContinuePinValidationSuccess(), pinValidation: pinValidation, timeOut: timeOut, onBackHandlerAfterTimeLock: onBackHandlerAfterTimeLock, hideAllAccessPopup: hideAllAccessPopup, showAllAccessAfterTimeLock: showAllAccessAfterTimeLock }));
            case "resetPin":
                return (React.createElement(ResetPin, { onBack: goBack, onContinue: (id) => onContinueResetPinHandler(id), pinValidation: pinValidation }));
            case "recoveryQ":
                return (React.createElement(ResetSecurityQuestionCard, { onBack: goBack, onContinue: recoveryQuestionHandler, pinValidation: resetPin }));
            case "resetRecoveryQ":
                return (React.createElement(SecurityQuestionCard, { onBack: goBack, onContinue: resetRecoveryQuestionHandler, header: Strings.SECURITY_QUESTIONS, subHeader: Strings.SECURITY_ANSWER_TITLE, forgotAnswer: true, label: Strings.FORGOT_PIN_RESET }));
            case "forgotAnswer":
                return (React.createElement(GetInTouch, { onContinue: () => {
                        navigateTo(config.standardPageRouteFragments.home);
                    } }));
            case "success":
                return React.createElement(Sucess, { onContinue: parentalLockSuccess });
            case "forgotPin":
                return (React.createElement(SecurityQuestionCard, { onBack: goBack, onContinue: () => {
                        onContinue("step8");
                    }, header: Strings.SECURITY_QUESTIONS, subHeader: Strings.SECURITY_ANSWER_TITLE, forgotAnswer: true, onForgotAnswer: onForgotPinRecoveryQuestionHandler, label: Strings.FORGOT_PIN_RESET, recoveryq1CustomAttr: recoveryq1CustomAttr, recoveryq2CustomAttr: recoveryq2CustomAttr, pinValidation: pinValidation }));
            case "createPin":
                return (React.createElement(CreatePin, { onContinue: (id) => onCreateNewPinHandler(id), header: Strings.CREATE_NEW_PIN, pinlabel: Strings.NEW_PIN, confirmPinLabel: Strings.CONFIRM_NEW_PIN, label: Strings.RESET_PIN, pinValidation: pinValidation, flow: "forgotPin" }));
            default:
                return;
        }
    };
    return React.createElement(React.Fragment, null,
        renderPages(route),
        " ");
};

